export const DEFAULT_DEVICE_ID = "default";
export const DEFAULT_GRID_LAYOUT_PAGE_SIZE = 8;
export const DEFAULT_PIP_LAYOUT_PAGE_SIZE = 4;
export const MIN_GRID_LAYOUT_PAGE_SIZE = 2;
export const MAX_GRID_LAYOUT_PAGE_SIZE = 16;
export const DEFAULT_SPEAKER_LAYOUT_PAGE_SIZE = 6;
export const MIN_SPEAKER_LAYOUT_PAGE_SIZE = 2;
export const MAX_SPEAKER_LAYOUT_PAGE_SIZE = 16;
export const MIN_PIP_LAYOUT_PAGE_SIZE = 2;
export const MAX_PIP_LAYOUT_PAGE_SIZE = 6;
